module.exports = {"dateFormat":"M/D/YYYY","dateTimeFormat":"M/D/YY HH:mm"}


//////////////////
// WEBPACK FOOTER
// ./src/defaults/formatters.json
// module id = 961
// module chunks = 0